import type { ParentBranchObject, StringRangeObject } from '@ps-smart-cp/ppfw-client';
import {
  Characters,
  type ItemAttributes,
  ItemName,
  type ItemNames,
  Locale,
  ParentBranch,
  StringRange,
} from '@ps-smart-cp/ppfw-client';

interface Schema {
  /**
   * 更新番号・親
   */
  updateNoParent: string;
  /**
   * 更新番号・枝
   */
  updateNoBranch: string;
  /**
   * 更新番号・親(抽出条件)
   */
  updateNoParentRange: StringRangeObject;
  /**
   * 更新番号
   */
  updateNo: string;
  /**
   * 更新番号(grid)
   */
  updateNoGrid: ParentBranchObject;
}

interface Record {
  updateNoParent: string;
  updateNoBranch: string;
  updateNoParentFrom: string;
  updateNoParentTo: string;
  updateNo: string;
  updateNoGrid: string;
  historyProcessClass: string;
}

const attributes = {
  updateNoParent: Characters.preset.alphanumericals({ maxLen: 15 }),
  updateNoBranch: Characters.preset.alphanumericals({ maxLen: 8 }),
  updateNoParentRange: StringRange.of(
    Characters.preset.numerical({ minLen: 15, maxLen: 15 }),
    Characters.preset.numerical({ minLen: 15, maxLen: 15 }),
  ),
  updateNoGrid: ParentBranch.of(
    Characters.preset.halfWidth({ minLen: 15, maxLen: 15 }),
    Characters.preset.numerical({ minLen: 8, maxLen: 8 }),
  ),
} satisfies ItemAttributes<Schema>;

const names = {
  updateNoParent: ItemName.of([Locale.ja, '更新番号・親'], [Locale.en, 'Update No Parent']),
  updateNoBranch: ItemName.of([Locale.ja, '更新番号・枝'], [Locale.en, 'Update No Branch']),
  updateNo: ItemName.of([Locale.ja, '更新番号'], [Locale.en, 'Update No']),
  updateNoGrid: ItemName.of([Locale.ja, '更新番号'], [Locale.en, 'Update No']),
} satisfies ItemNames<Schema>;

const ledgerRegistration = {
  names,
  attributes,
};

interface LedgerRegistration {
  schema: Schema;
  record: Record;
}

export { ledgerRegistration };
export type { LedgerRegistration };
